import React, { Component } from 'react'
import AOS from 'aos';

import quote from "../../assets/images/quote.svg"
// import testifier from "../../assets/images/Testifier.png"

class Testimonial extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <div className="testimonial">
                <div className="testimonial-image"  data-aos="fade-up" data-aos-delay="70" data-aos-duration="1200">
                    <img src={quote} alt="quote icon" />
                    <h2>WHAT PEOPLE ARE SAYING</h2>
                </div>
                <div className="testimony-slide">
                    <div className="testimony-card"  data-aos="fade-up" data-aos-delay="70" data-aos-duration="1300">
                        <div className="card-head">
                            {/* <img src={testifier} alt="Testifier Icon" /> */}
                            <div>
                                <h6>BUSARI HABEEB</h6>
                                <p>Works at a bank</p>
                            </div>
                        </div>
                        <div className="card-body">
                            <p>
                                I’m glad I go know Hendray Finvest cause they basically changed my whole perception about forex trading as i had lost hope in it until we crossed path. I look forward to bigger transactions between us. <br /> To everyone in this company, I say thank you!
                            </p>
                        </div>
                    </div>
                    <div className="testimony-card"  data-aos="fade-up" data-aos-delay="90" data-aos-duration="1400">
                        <div className="card-head">
                            {/* <img src={testifier} alt="Testifier Icon" /> */}
                            <div>
                                <h6>ONAMUSI ONATOLU</h6>
                                <p>Works at a bank</p>
                            </div>
                        </div>
                        <div className="card-body">
                            <p>
                                When it comes to Forex Trading, Investment and training there are loads of commentators that talk a good game, but Hendryfinvest help you make it happen. They have enabled me, coached me and given me the confidence to share the good news widely and openly. <br/> Try them today and you wont regret you did."Onomeous"
                            </p>
                        </div>
                    </div>
                    <div className="testimony-card"  data-aos="fade-up" data-aos-delay="100" data-aos-duration="1500">
                        <div className="card-head">
                            {/* <img src={testifier} alt="Testifier Icon" /> */}
                            <div>
                                <h6>OYEKAN ADEBAYO</h6>
                                <p>Network Administrator</p>
                            </div>
                        </div>
                        <div className="card-body">
                            <p>
                                Until we crossed path, I had already lost hope about the whole concept of forex and, I am glad we met Hendray Finvest, as they changed my whole perspective totally! I actually wished I had this information earlier. I was a little skeptical about it because of the conventional trust issues regarding the issue of money but, Hendray finvest has always been on point.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Testimonial;